export enum AccessActionType {
    ReadOnly = 0,
    Update,
}
